//Public routes
export const home = "/";
export const pricing = "/pricing";
export const signUp = "/sign-up";
export const login = "/login";
export const verify = "/verify";
export const demo = "/request-demo";

//Private routes
export const profile = "/profile";

export const listProjects = "/list-projects";

export const users = "/users";

export const project = (projectId?: string) => absolute(["project", projectId]);

export const contractorDashboard = (projectId: string) => absolute(["dashboard", projectId]);
export const contractorDashboardMonthly = (projectId: string) => absolute(["dashboard", projectId, "monthly"]);

export const contractors = (projectId: string) => absolute(["sub-contractors", projectId]);

export const packages = (projectId: string) => absolute(["packages", projectId]);

export const contractorEmployees = (projectId: string) => absolute(["employees", projectId]);

export const contractorPolicies = (projectId: string) => absolute(["policies", projectId]);

export const contractorPackage = (projectId: string, packageId: string) => absolute(["package", projectId, packageId]);

export const analyticsSpend = (projectId: string) => absolute(["analytics/spend", projectId]);

export const analyticsLabourHours = (projectId: string) => absolute(["analytics/labourHours", projectId]);

export const contractorReports = (projectId: string) => absolute(["report", projectId]);

export const labourHours = (projectId: string, reportId: string) =>
  absolute(["report", projectId, reportId, "labour-hours"]);

export const socialProcurement = (projectId: string, reportId: string) =>
  absolute(["report", projectId, reportId, "social-procurement"]);

export const directory = (projectId: string) => absolute(["directory", projectId]);

export const absolute = (params: (string | number | undefined)[]): string => `/${params.filter((a) => !!a).join("/")}`;
